import {TranslationInterpreter} from '../../TranslationProvider/TranslationContext';

const EMOJI_DATA = [
  {key: 'smileys', emojis: ['😀', '😄', '😉', '😊', '😍', '🤝']},
  {key: 'nature', emojis: ['🌞', '🌿', '🌲', '🌷', '🍀', '🔥']},
  {key: 'transport', emojis: ['🚗', '🚙', '🛻', '🏎️', '🛞', '⛽']},
  {key: 'symbols', emojis: ['⭐', '✅', '⚠️', '💡', '📌', '🛠️']},
] as const;

export function getEmojiCategories(t: TranslationInterpreter) {
  return EMOJI_DATA.map((category) => ({
    label: t(`richText.emojiCategories.${category.key}`),
    emojis: category.emojis,
  }));
}
